<template>
  <v-img :src="src"></v-img>
</template>

<script>
export default {
  data() {
    return {
      src: require("../assets/MoonPhase/Moon-Phase.jpg")
    };
  }
};
</script>